import { getSiteBaseUrl } from '@/lib/siteBaseUrl'

const regex = /#([^\s#]+)/g

function transformTextWithHashtag(text: string) {
	return text.replace(
		regex,
		`<a href="${getSiteBaseUrl()}/sharing/search?hashtag=$1">#$1</a>`,
	)
}

export default transformTextWithHashtag
